// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

// Spring Boot Gateway (AWS ALB)
const api_base_url = '/qa/consumer-onboarding';

export const environment = {
  production: false,
  development: false,
  local: false,
  env: 'qa',
  tcb_dns: 'https://join-ext-qa.texascapitalbank.com',
  bask_dns: 'https://join-ext-qa.baskbank.com',
  app_settings_version: 1,
  api_base_url: api_base_url,
  api_base_url_mando: api_base_url + '/mando',
  api_base_url_falcon: api_base_url + '/falcon',
  api_base_url_q2caliper: api_base_url + '/falcon/caliper/api', //TODO: need to refactor caliper into its own service
  api_base_url_leia: api_base_url + '/leia',
  api_base_url_skyhopper: api_base_url + '/skyhopper',
  api_auth_token_url: '/auth/token-service',
  googleTagManagerId: "G-WFF2D7Z2PM",
  googleUniversalAnalyticsId: "UA-40750267-10",
  show_error_dialogs: false,
  productSelectionUrl: "https://b-stage.texascapitalbank.com/personal-banking/",
  socureSdkKey: "01b48f91-bdd2-4ec7-94be-4cc77575cad6",
  socureIdPlusKey: "75eef6ed-d723-4145-8e01-56628cf2f317",
  socureDeviceRiskEndpoint: "https://devicerisk.texascapitalbank.com/",
  socureProcessFlow: 1,
  alloyIsInProductionEnvironment: false,
  //mParticleKey: "us1-8396373f1d0bbc419bd5422c37440b1c",
  //BaskmParticleKey: "b9f4a77b0f885145a56c5955fcd18444",
  dataDogClientToken: "pubd69460a5e170cae40e180137959b7032",
  dataDogApplicationId: "3500ac47-fce8-4d61-89f1-78dd31fd8d82",
  dataDogService: "consumeronboarding-bb8-qa",
  oktaToken: "",
  showDebugInfo: true,
  localTokenServer: "",
  offlineResponses: [],
  cdpTcbSrc: "//cdn.evgnet.com/beacon/q55685555557kq63k3n3n3d665550778/tcb_staging/scripts/evergage.min.js",
  cdpBaskSrc: "//cdn.evgnet.com/beacon/q55685555557kq63k3n3n3d665550778/baskbank_staging/scripts/evergage.min.js"
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
